import styled from 'styled-components'
import { ThemeSelectors, TypeSmart } from '@at/design-system-foundation'

export const StyledSearchListingsLoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.88);
    z-index: 2;
`
export const StyledSearchListingsLoadingContent = styled.div`
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    path {
        fill: ${({ theme }) => theme.color.text.default};
    }
`
export const StyledSearchListingsLimitReached = styled(TypeSmart)`
    width: 100%;
    text-align: center;
    margin: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 5}px 0;
    grid-column: 1 / -1;
`
